import { render, staticRenderFns } from "./ListSPMPage.vue?vue&type=template&id=520f0470&scoped=true&"
import script from "./ListSPMPage.vue?vue&type=script&lang=js&"
export * from "./ListSPMPage.vue?vue&type=script&lang=js&"
import style0 from "./ListSPMPage.vue?vue&type=style&index=0&id=520f0470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520f0470",
  null
  
)

export default component.exports